export default {
  common: {
    analyze: "분석",
    compare: "비교",
    search: "검색",
    close: "닫기",
    cancel: "취소",
    add: "추가",
    save: "저장",
    share: "공유",
    home: "홈",
    back: "뒤로",
    loading: "로딩 중...",
    error: "오류",
    noData: "데이터 없음",
    years: "{{count}}년",
    score: "{{score}}점",
    lightMode: "라이트 모드",
    darkMode: "다크 모드",
    language: "언어",
  },
  home: {
    title: "핀스코어\nAI 주식 재무분석",
    subtitle: "DART 공시 데이터 기반 6개 카테고리 자동 분석으로\n장기 투자 적합성을 평가합니다",
    searchPlaceholder: "기업명을 입력하세요 (예: 삼성전자, 넥센타이어)",
    recentAnalysis: "최근 분석",
    compareStart: "비교 시작",
    addCompany: "기업 추가",
    tags: {
      valuation: "PER/PBR 밸류에이션",
      profitability: "ROE/ROA 수익성",
      growth: "매출 성장성",
      stability: "부채 안정성",
      dividend: "배당 분석",
    },
  },
  analyze: {
    searchOther: "다른 기업 검색",
    companyOverview: "기업 개요",
    stock: "종목",
    codeMarket: "종목코드 / 시장",
    currentPrice: "현재가",
    marketCap: "시가총액",
    dividendCycle: "배당 주기",
    financialSummary: "재무 요약",
    investmentRatios: "주요 투자지표",
    investmentRatiosDesc: "PER(주가수익비율)은 주가가 이익의 몇 배인지, PBR(주가순자산비율)은 자산가치의 몇 배인지를 나타냅니다. ROE(자기자본이익률)는 투자한 돈 대비 얼마나 벌었는지, 부채비율은 빚이 자기 돈의 몇 배인지를 보여줍니다. 일반적으로 PER/PBR은 낮을수록, ROE는 높을수록, 부채비율은 낮을수록 좋습니다.",
    categoryAnalysis: "카테고리별 분석",
    categoryDesc: "6개 카테고리별 100점 만점으로 평가합니다. 밸류에이션은 현재 주가가 적정한지, 수익성은 돈을 잘 버는지, 성장성은 매출이 늘고 있는지, 안정성은 빚이 적은지, 배당은 주주에게 이익을 돌려주는지, 현금흐름은 실제 현금을 잘 벌어들이는지를 평가합니다. 70점 이상이면 우수, 45점 이상이면 보통, 미만이면 주의가 필요합니다.",
    trendAnalysis: "트렌드 분석",
    investmentOpinion: "종합 투자 의견",
    aiComment: "AI 투자 코멘트",
    realtimeValuation: "실시간 밸류에이션",
    realtimeDesc: "현재 주가가 비싼 걸까, 싼 걸까?",
    realtimeExplain: "PER은 주가가 기업 이익의 몇 배인지, PBR은 자산가치의 몇 배인지를 나타냅니다. 과거 중앙값과 비교하여 현재 주가 수준을 판단합니다. 수치가 낮을수록 상대적으로 저평가된 상태입니다.",
    industryPeers: "동종 업종 기업",
    industryPeersDesc: "같은 업종으로 분류된 상장기업 목록입니다. 기업을 클릭하면 해당 기업의 상세 분석을 실행합니다.",
    disclaimer: "본 분석은 과거 재무데이터 기반 자동 분석이며, 투자 판단의 참고 자료로만 활용하시기 바랍니다.",
    aiDisclaimer: "AI가 생성한 분석 의견이며 투자 권유가 아닙니다.",
  },
  compare: {
    title: "종목 비교",
    close: "비교 종료",
    desc: "같은 기간의 재무 데이터를 기준으로 비교합니다. 각 지표에서 가장 우수한 기업이 색상으로 강조됩니다.",
    scoreCompare: "총점 비교",
    categoryCompare: "카테고리 점수 비교",
    keyMetrics: "핵심 지표 비교",
    financialCompare: "재무 요약 비교",
    ratioCompare: "투자지표 비교",
    trendCompare: "트렌드 비교",
    opinionCompare: "투자 의견 비교",
    aiCompare: "AI 코멘트 비교",
    valuationCompare: "실시간 밸류에이션 비교",
    duplicateError: "같은 기업이 중복 입력되어 있습니다.",
  },
  share: {
    kakao: "카카오톡",
    nativeShare: "공유하기",
    copyLink: "링크 복사",
    copied: "복사됨!",
    saveImage: "이미지 저장",
    saving: "저장 중...",
    linkCopied: "링크가 클립보드에 복사되었습니다.",
    imageSaved: "이미지가 저장되었습니다.",
    imageFailed: "이미지 저장에 실패했습니다.",
  },
  notFound: {
    title: "페이지를 찾을 수 없습니다",
    desc: "요청하신 페이지가 존재하지 않거나 이동되었습니다.",
    goHome: "홈으로 돌아가기",
  },
  footer: {
    disclaimer: "본 서비스는 과거 재무데이터 기반 자동 분석이며, 투자 판단의 참고 자료로만 활용하시기 바랍니다.",
  },
  valuation: {
    undervalued: "저평가",
    fair: "적정",
    overvalued: "고평가",
    medianPER: "과거 중앙값",
    realtimePER: "실시간 PER",
    realtimePBR: "실시간 PBR",
  },
  categories: {
    valuation: "밸류에이션",
    profitability: "수익성",
    growth: "성장성",
    stability: "안정성",
    dividend: "배당",
  },
};
